import { Box, Text } from 'grommet';
import { Tag } from 'grommet-icons';
import React, { useRef, useCallback } from 'react';
import { GameSummary } from './playerHooks';
import GameSummaryCard from './GameSummaryCard';

interface GameSummaryCarouselProps {
  gameSummaries: GameSummary[];
  fetchMore: () => void;
  hasMore: boolean;
}

const GameSummaryCarousel: React.FC<GameSummaryCarouselProps> = ({
  gameSummaries,
  fetchMore,
  hasMore,
}) => {
  const carouselObserver = useRef<IntersectionObserver | null>(null);

  // Observe the last video in the carousel
  const lastVideoRef = useCallback(
    (node: HTMLElement | null) => {
      if (!hasMore || !node) {
        return;
      }

      if (carouselObserver.current) {
        carouselObserver.current.disconnect();
      }

      carouselObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          fetchMore(); // Load more when the last video is visible
        }
      });

      carouselObserver.current.observe(node);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [hasMore]
  );

  return (
    <Box margin="medium">
      {gameSummaries && gameSummaries.length > 0 ? (
        <Box>
          <Box
            direction="row"
            align="center"
            gap="small"
            margin={{ left: 'small' }}
          >
            <Tag />
            <Text weight="bold">Tagged Game Highlights</Text>
          </Box>
          <Box
            style={{
              whiteSpace: 'nowrap',
            }}
            overflow={{ horizontal: 'scroll', vertical: 'hidden' }}
            direction="row"
          >
            {gameSummaries.map((gameSummary, i) => (
              <div
                key={`game-summary-${i}`}
                ref={i === gameSummaries.length - 1 ? lastVideoRef : null}
              >
                <GameSummaryCard gameSummary={gameSummary} />
              </div>
            ))}
          </Box>
        </Box>
      ) : null}
    </Box>
  );
};

export default GameSummaryCarousel;
